import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import TileGrid from "./TileGrid";

export default function FolderSection({ folder, items }) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        {folder.icon && <span style={{ marginRight: 8 }}>{folder.icon}</span>}
        {folder.name}
      </Typography>
      {folder.description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {folder.description}
        </Typography>
      )}
      <TileGrid items={items} />
      <Divider sx={{ mt: 3 }} />
    </Box>
  );
}
